jQuery(document).ready(function ContactForm($) {
	var prepareMap = function($container) {
		var point;
		var center;
		var map;
		var marker;
		var infowindow;
		
		if($container.length > 0) {
		
			point = {lat: parseFloat($container.data('latitude')), lng: parseFloat($container.data('longitude'))};
			
			center = {
				lat: point.lat,
				lng: point.lng
			};
			
			map = new google.maps.Map($container.get(0), {
			    center: center,
			    zoom: 14,
			    scrollwheel: false
		    });
			
			marker = new google.maps.Marker({
				position: point,
				map: map,
				title: $container.data('name')
			});
			
			$container.click(function() {
		//			return false;
			})
			
			$container.data('map', {
				recenter: function() {
					map.setCenter(center)
				}
			});
		}
	};
	
	prepareMap($('.info__map__container'));
	
	
	$('.contact-form').submit(function() {
		var $this = $(this);
		
		$.ajax({
			type: "POST",
			url: $this.attr('action'),
			data: $this.serialize()
		}).then(function(response) {
			console.log(response);
			var $res = $(response);
			$this.empty();
			$this.append($res.children());
		})
		.fail(function(response) {
			console.error(response);
		});
		
		return false;
	});
});